module.exports = __webpack_public_path__ + "static/media/icon_video.8ec53666.svg";